/**
 * cart-sync-guard.js
 * ------------------------------------------------------------
 * Sepet güvenlik ağı: sayaç + bayat drawer düzeltmesi.
 * Tema JS'ini değiştirmez; DOM'u gerçek /cart.js ile tutarlı tutar.
 */
(function () {
  'use strict';

  var CART_UPDATE_EVENT = 'cart:update';
  var syncTimer = null;
  var inFlight = false;
  var rerunRequested = false;

  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(runSync, typeof delay === 'number' ? delay : 250);
  }

  function normalizeSectionId(sectionId) {
    return String(sectionId || '').replace(/^shopify-section-/, '');
  }

  function getDrawerComponent() {
    return document.querySelector('cart-items-component[data-drawer]');
  }

  function drawerHasRows() {
    var comp = getDrawerComponent();
    return !!comp && !!comp.querySelector('.cart-items__table-row');
  }

  function updateDialogEmptyState(shouldHaveItems) {
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (dialog) {
      dialog.classList.toggle('cart-drawer--empty', !shouldHaveItems);
    }
  }

  async function runSync() {
    if (inFlight) {
      rerunRequested = true;
      return;
    }
    inFlight = true;
    rerunRequested = false;

    try {
      var res = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var count = Number(cart.item_count) || 0;

      updateCounters(count);
      await refreshDrawerIfStale(cart);
    } catch (err) {
      /* sessiz */
    } finally {
      inFlight = false;
      if (rerunRequested) scheduleSync(150);
    }
  }

  function updateCounters(count) {
    var icons = document.querySelectorAll('cart-icon');
    icons.forEach(function (icon) {
      var countEl = icon.querySelector('[ref="cartBubbleCount"]');
      var bubble = icon.querySelector('[ref="cartBubble"]');
      if (countEl) {
        countEl.textContent = count < 100 ? String(count) : '';
        countEl.classList.toggle('hidden', count === 0);
      }
      if (bubble) {
        bubble.classList.toggle('visually-hidden', count === 0);
      }
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    try {
      sessionStorage.setItem(
        'cart-count',
        JSON.stringify({ value: String(count), timestamp: Date.now() })
      );
    } catch (e) {
      /* storage kapalı olabilir */
    }
  }

  async function refreshDrawerIfStale(cart) {
    var comp = getDrawerComponent();
    if (!comp) return;

    var shouldHaveItems = (Number(cart.item_count) || 0) > 0;
    var hasRows = drawerHasRows();

    updateDialogEmptyState(shouldHaveItems);

    if (hasRows === shouldHaveItems) return;

    var sectionId = normalizeSectionId(comp.dataset.sectionId);
    if (!sectionId) return;

    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    var res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return;

    var html = await res.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshSection =
      doc.getElementById('shopify-section-' + sectionId) || doc.querySelector('.shopify-section');
    var fresh = freshSection ? freshSection.querySelector('cart-items-component[data-drawer]') : null;

    if (!fresh) return;

    var current = getDrawerComponent();
    if (!current) return;

    current.innerHTML = fresh.innerHTML;
    updateDialogEmptyState(shouldHaveItems);
  }

  document.addEventListener(CART_UPDATE_EVENT, function (event) {
    var detail = event && event.detail;
    var data = detail && detail.data;
    var resource = detail && detail.resource;

    if (data && data.didError) {
      scheduleSync(200);
      return;
    }

    var immediateCount =
      resource && resource.item_count != null
        ? Number(resource.item_count)
        : data && data.cartCount != null
          ? Number(data.cartCount)
          : data && data.itemCount != null
            ? Number(data.itemCount)
            : null;

    if (immediateCount != null && !Number.isNaN(immediateCount)) {
      updateCounters(immediateCount);
    }

    // Tema section morph'u tamamlansın diye sections varsa biraz bekle
    if (data && data.sections) {
      scheduleSync(450);
    } else {
      scheduleSync(180);
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      var trigger =
        event.target &&
        event.target.closest &&
        event.target.closest(
          '[data-testid="cart-drawer-trigger"], .header-actions__cart-icon, a[href$="/cart"], a[href*="/cart?"]'
        );
      if (trigger) scheduleSync(80);
    },
    true
  );

  function initialSync() {
    scheduleSync(600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSync, { once: true });
  } else {
    initialSync();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) scheduleSync(0);
  });
})();
